"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GOAL_SPORT_CONFIGURATION = exports.PlayCode = void 0;
var PlayCode;
(function (PlayCode) {
    PlayCode["Goal"] = "goal";
    PlayCode["MissedShot"] = "missed_shot";
    PlayCode["Assist"] = "assist";
    PlayCode["Save"] = "save";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
exports.GOAL_SPORT_CONFIGURATION = {
    play_codes: Object.values(PlayCode),
};
//# sourceMappingURL=definitions.js.map